if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"frontend","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2(50|620|707|842|99)|5(044|314|911)|6(022|891|912)|7(148|207|47)|8(196|202|485|795|853|876|940)|[19]282|1439|3997|407|4330|9803)$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}